import { BlockProductsType, HeroBannerType, LandingPageType, ReferencePageType } from '../models/Content';

export const selectHeroBanners = (pageData: LandingPageType): HeroBannerType[] => pageData?.fields?.heroBanner;

export const selectContents = (pageData: LandingPageType) => pageData?.fields?.contents;

export const selectProductsQueryKey = (productsBlock: BlockProductsType) =>
    productsBlock?.fields?.productsQuery?.fields?.query;

export const selectReferencedPage = (referencePage: ReferencePageType) => referencePage?.fields.referencedPage;
